
import { Component, Prop, Vue } from "vue-property-decorator";
import Directory from "./components/knowledgeDirectory.vue";
import {
  addCollection,
  delCollection,
  getKnowledgeDraftsList,
  getKnowledgeScourceList,
} from "@/api/knowledge";
import { UserModule } from "@/store/modules/user";
import TemplateAddedProgress from "../template/TemplateAddedProgress.vue";

@Component({
  name: "KnowledgeBase",
  components: {
    Directory,
    TemplateAddedProgress,
  },
})
export default class extends Vue {
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  private winheight = window.innerHeight - 95;
  private tableData = [];
  private isSelectedMenu: any = "";

  private loading = false;
  private clickType = 0;

  private pid = "0";
  private pids: any = [];

  private expandData = {};
  private refData: any = {};

  created() {
    this.getKnowledgeScourceList("0");
  }
  private getKnowledgeScourceList(isCollectionList: string) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.inputSearch,
      is_collection: 1,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      is_collection_list: isCollectionList,
    };
    if (this.pid) {
      params.pid = this.pid;
    }
    getKnowledgeScourceList(params).then((res) => {
      if (res.data) {
        this.pids = res.data.catalogue;
      }
      if (res.data && res.data.list) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
        this.pagination.total = 0;
      }
    });
  }
  private changeNode(item: any) {
    this.pagination.currentPage = 1;
    this.pid = item.id;
    this.getKnowledgeScourceList("0");
  }
  private allClick() {
    this.pagination.currentPage = 1;
    if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.pid = "0";
      this.getKnowledgeScourceList("0");
    }
  }
  private backUp() {
    this.pids.pop();
    this.pagination.currentPage = 1;
    if (this.pids && this.pids.length > 0) {
      this.pid = this.pids[this.pids.length - 1].id;
    } else {
      if (this.clickType === 3) {
        this.pid = "";
      } else {
        this.pid = "0";
      }
    }
    if (this.clickType === 3) {
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }
  private handleClick(type: number) {
    this.isSelectedMenu = type;
    this.pagination.currentPage = 1;
    this.clickType = type;
    this.pid = "";
    this.getKnowledgeScourceList("1");
  }
  private getKnowledgeDraftsList() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.inputSearch,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    getKnowledgeDraftsList(params).then((res) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
        this.pagination.total = 0;
      }
    });
  }

  private inputSearch = "";
  // 搜索
  handleSearch() {
    if (this.clickType === 3) {
      this.pagination.currentPage = 1;
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.pagination.currentPage = 1;
      this.getKnowledgeScourceList("0");
    }
  }
  // 清空
  handleClear() {}
  private handleCurrentChange(page: any) {
    this.pagination.currentPage = page;
    if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }
  private handlePageSizeChange(size: any) {
    this.pagination.pageSize = size;
    if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }

  private clickFile(row: any) {
    if (this.clickType === 0) {
      this.expandData = row;
    }
    if (parseInt(row.type) === 0) {
      this.pagination.currentPage = 1;
      this.pid = row.id;
      this.getKnowledgeScourceList("0");
    }
  }

  private starHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    addCollection(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.getKnowledgeScourceList("0");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private cancleHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    delCollection(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        if (this.clickType === 3) {
          this.pagination.currentPage = 1;
          this.pid = "";
          this.getKnowledgeScourceList("1");
        } else {
          this.getKnowledgeScourceList("0");
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  private detailsHandle(val: any) {
    if (parseInt(val.type) === 99) {
      this.$router.push({
        path: "details",
        query: val,
      });
    } else {
      window.open(val.full_path);
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
